export const CITY_OPTIONS = {
  PA: [
    "Panamá",
    "San Miguelito",
    "Arraiján",
    "La Chorrera",
    "Colón",
    "David",
    "Santiago",
    "Chitré",
    "Penonomé",
    "Las Tablas",
    "Changuinola",
    "Aguadulce",
  ],
  VE: [
    "Caracas",
    "Valencia",
    "Maracaibo",
    "Barquisimeto",
    "Maracay",
    "San Cristóbal",
    "Puerto La Cruz",
    "Lechería",
    "Barcelona",
    "Maturín",
    "Ciudad Guayana",
    "Mérida",
    "Barinas",
    "Coro",
    "Punto Fijo",
    "Cumaná",
  ],
  GT: [
    "Ciudad de Guatemala",
    "Mixco",
    "Villa Nueva",
    "Antigua Guatemala",
    "Quetzaltenango",
    "Escuintla",
    "Chimaltenango",
    "Cobán",
    "Huehuetenango",
    "Puerto Barrios",
    "Retalhuleu",
    "Mazatenango",
  ],
  DO: [
    "Santo Domingo",
    "Santiago de los Caballeros",
    "Punta Cana",
    "La Romana",
    "San Pedro de Macorís",
    "Puerto Plata",
    "Higüey",
    "San Francisco de Macorís",
    "La Vega",
    "Baní",
    "Bonao",
    "Barahona",
  ],
};

const normalized = (value) =>
  String(value || "")
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

const ALIASES = {
  "ciudad de panama": "panama",
  "panama city": "panama",
  guatemala: "ciudad de guatemala",
  "guatemala city": "ciudad de guatemala",
  santiago: "santiago de los caballeros",
};

export function cityKey(value) {
  const key = normalized(value);
  return ALIASES[key] || key;
}

export function citiesForCountry(countryCode) {
  return CITY_OPTIONS[String(countryCode || "PA").toUpperCase()] || CITY_OPTIONS.PA;
}

export function canonicalCity(countryCode, city) {
  const key = cityKey(city);
  return (
    citiesForCountry(countryCode).find((candidate) => cityKey(candidate) === key) ||
    String(city || "").trim()
  );
}
